/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Filter domains within a workspace. All filters are optional and combine with AND. Each resource
 *
 * @remarks
 * filter matches its ID or slug directly, even when its parent filters are omitted. A missing
 * resource or a resource that does not match the other filters produces an empty list.
 */
export type V1DomainsListDomainsRequestBody = {
  /**
   * Match domains whose project ID or slug equals this value. This filter does not require
   *
   * @remarks
   * an app or environment filter.
   */
  project?: string | undefined;
  /**
   * Match domains whose app ID or slug equals this value. This filter does not require a
   *
   * @remarks
   * project or environment filter.
   */
  app?: string | undefined;
  /**
   * Match domains whose environment ID or slug equals this value. This filter does not require
   *
   * @remarks
   * a project or app filter.
   */
  environment?: string | undefined;
  /**
   * The maximum number of domains one response contains.
   *
   * @remarks
   * A small limit makes the response smaller, but makes more requests necessary.
   */
  limit?: number | undefined;
  /**
   * The pagination cursor from the response that came before.
   *
   * @remarks
   * Send it to get the next page when that response has `hasMore: true`.
   */
  cursor?: string | undefined;
  /**
   * Free-form text to filter domains. Returns domains whose ID or name contains the search string. Matching is case-insensitive.
   */
  search?: string | undefined;
};

/** @internal */
export type V1DomainsListDomainsRequestBody$Outbound = {
  project?: string | undefined;
  app?: string | undefined;
  environment?: string | undefined;
  limit: number;
  cursor?: string | undefined;
  search?: string | undefined;
};

/** @internal */
export const V1DomainsListDomainsRequestBody$outboundSchema: z.ZodType<
  V1DomainsListDomainsRequestBody$Outbound,
  z.ZodTypeDef,
  V1DomainsListDomainsRequestBody
> = z.object({
  project: z.string().optional(),
  app: z.string().optional(),
  environment: z.string().optional(),
  limit: z.number().int().default(100),
  cursor: z.string().optional(),
  search: z.string().optional(),
});

export function v1DomainsListDomainsRequestBodyToJSON(
  v1DomainsListDomainsRequestBody: V1DomainsListDomainsRequestBody,
): string {
  return JSON.stringify(
    V1DomainsListDomainsRequestBody$outboundSchema.parse(
      v1DomainsListDomainsRequestBody,
    ),
  );
}
